import { TalepKalem } from './talep-kalem';
import { Master } from './master';
import { TalepGorsel } from './talep-gorsel';
import { TalepAciklama } from './talep-aciklama';

export class TalepKaydetRequest {

  id: number;
  subeId: number;
  talepTurId: number;
  urunGrupId: number;
  teslimYeriId: number;
  aciklama: string;
  teslimYeri: Master;
  talepKalemler: TalepKalem[];
  talepGorseller: TalepGorsel[];
  talepAciklama: TalepAciklama;
  cariId: number;
  urunGrupText: string;
}
